import React, { useState } from 'react';
import { observer } from 'mobx-react-lite';
import { kenoBetStore } from '../../../../store/kenoBetStore';
import TicketNumberCountSlider from './ticketNumberCountSlider';
import { applicationStore } from '../../../../store/applicationStore';
import { TranslationKeys } from '../../../../core/constants/translationKeys';
import useTranslation from '../../../../hooks/useTranslation';

const TicketNumberCount = observer(() => {
  const { autoSelect, isBetsClosed, setNumbersCountInTicket, numbersCountInTicket } = kenoBetStore;
  const { isKeno8 } = applicationStore;
  const [isOpenTicketNumbersCountSlider, setIsOpenTicketNumbersCountSlider] = useState(false);
  const t = useTranslation();

  return (
    <div className={`keno-tickets-multipller ${isOpenTicketNumbersCountSlider ? 'active' : ''}`}>
      <div className='keno-tickets-multipller-inner'>
        <div
          className={`keno-tickets-number ${isBetsClosed ? 'disabled' : ''}`}
          onClick={() => setIsOpenTicketNumbersCountSlider(!isOpenTicketNumbersCountSlider)}
        >
          <span className='keno-tickets-number-txt'>{numbersCountInTicket}</span>
          {/* eslint-disable-next-line jsx-a11y/control-has-associated-label */}
          <button type='button' className='multipller-action action-up'>
            <span className='icon-arrow-up-new arrow-icon' />
            <span className='btn-txt-label' />
          </button>
        </div>
        {isOpenTicketNumbersCountSlider && (
          <TicketNumberCountSlider
            isKeno8={isKeno8}
            setIsOpenTicketNumbersCountSlider={setIsOpenTicketNumbersCountSlider}
            setNumbersCountInTicket={setNumbersCountInTicket}
          />
        )}
        <button
          type='button'
          className={`switch-btn icon-switch-new ${isBetsClosed ? 'disabled' : ''}`}
          data-title={t(TranslationKeys.Random)}
          onClick={autoSelect}
        >
          <span className='btn-txt-label'>Switch</span>
        </button>
      </div>
    </div>
  );
});
export default TicketNumberCount;
